import eventInit from "./event-init";
import eventGallery from "./event-gallery";
import eventCampaigns from "./event-campaigns";
import prozisEventQueue from "../../../../../../../src-js/monitor-user-behaviour-2/prozis-event-queue.js";


export default {

    /**
     * 
     * @param {*} groupId 
     * @param {*} status 
     * @param {*} rawProducts 
     */
    addInit(groupId, status, rawProducts, pack){
        let data = eventInit.getData(groupId, status, rawProducts, pack);
        if(data){
            this.addEvent('init', data);
        }
    },

    /**
     * Use selected another product ID (grouped products) 
     * @param {*} id 
     */
    addGroupIdChange(id){
        this.addEvent('groupIdChange', {id: id});
    },

    /**
     * User selected variant
     * @param {*} id 
     * @param {*} sku 
     * @param {*} skus 
     */
    addSkuSelected(id, sku, skus){
        const d = {id: id, sku: sku};
        if(skus){
            d['skus'] = skus;
        }
        this.addEvent('skuSelected', d);
    },

    /**
     * User liked/unliked product
     * @param {*} id 
     * @param {*} liked 
     */
    addLike(id, liked){
        if(liked !== null){
            this.addEvent('like', {id: id, liked: liked}, true);
        }
    },

    /**
     * TODO: confirm if has been deprecated with black rabbit?
     * @param {*} groupId 
     * @param {*} sku 
     * @param {*} hasVideo 
     * @param {*} info 
     */
    addGallery(groupId, sku, hasVideo, info){
        this.addEvent('gallery', eventGallery.getData(groupId, sku, hasVideo, info));
    },

    /**
     * User cliked on image (this event is only triggered in desktop)
     * TODO: confirm if has been deprecated with black rabbit?
     * @param {*} groupId 
     * @param {*} sku 
     * @param {*} slot 
     */
    addGalleryClick(groupId, sku, slot){
        this.addEvent('galleryClick', eventGallery.getDataImgClick(groupId, sku, slot));
    },

    /**
     * User swiped to view another image (this event is only triggered in mobile)
     * TODO (not implemented)
     * @param {*} groupId 
     * @param {*} sku 
     * @param {*} slot 
     */
    addGallerySlide(groupId, sku, slot){
        this.addEvent('gallerySlide', eventGallery.getDataImgClick(groupId, sku, slot));
    },

    /**
     * User zoomed image 
     *  - desktop mode: zoom is a modal with thumbs, user cliked on one thumb
     *  - mobile mode: user clicked on image and zoom is opened
     * @param {*} groupId 
     * @param {*} sku 
     * @param {*} slot 
     */
    addImageZoom(groupId, sku, slot){
        if(!groupId && !sku){
            // sometimes page is slower fetching data and user opens image zoom
            return;
        }
        this.addEvent('imageZoom', eventGallery.getDataImgClick(groupId, sku, slot));
    },

    /**
     * Campaigns are loaded and displayed on page
     * TODO: confirm if has been deprecated with black rabbit?
     * @param {*} groupId 
     * @param {*} data 
     */
    addCampaigns(groupId, data){
        this.addEvent('campaigns', eventCampaigns.getData(groupId, data));
    },

    /**
     * User clicked on (i) to view more details about campaign
     * TODO: implement :)
     * @param {*} data 
     */
    addCampaignViewed(data){
        this.addEvent('campaignView', eventCampaigns.getDataViewed(data));
    },

    /**
     * User copied coupon code to clipboard (clicked on the copy icon)
     * TODO: implement :)
     * @param {*} data 
     */
    addCampaignCouponCopied(data){
        this.addEvent('campaignCouponCopied', eventCampaigns.getDataViewed(data));
    },

    /**
     * User loaded "nutritional table" tab (desktop) or modal (mobile)
     * @param {*} groupId 
     * @param {*} sku 
     */
    addNutTableViewed(groupId, sku){
        this.addEvent('viewNutritionTable', {id: groupId, sku: sku});
    },

    /**
     * User loaded "info and care" (desktop) or modal (mobile)
     * @param {*} id 
     * @param {*} sku 
     */
    addInfoCareViewed(id, sku){
        this.addEvent('viewInfoCare', {id: id, sku: sku});
    },

    /**
     * User is browsing through comments (comments tab)
     * TODO: Event is being triggered by backend (comments/list), confirm if has been deprecated with black rabbit? 
     * @param {*} groupId 
     * @param {*} page 
     * @param {*} pageTotal 
     */
    addCommmentsViewed(groupId, page, pageTotal){
        this.addEvent('commentsViewed', {id: groupId, page: page, pageTotal: pageTotal});
    },

    addEvent(action, data, save = false) {
        if(window.location.port === '8080' || (window.mub && window.mub.logger && window.mub.logger.verbose)){
            // only do console.log if MUB logger is verbose
            console.log('PDP EVENT:', action, data);
        }
        
        prozisEventQueue.addEvent('product', action, data, save);
    },   

};